import React from "react";
import CheckupPlanFormPage from "../components/checkup-plans/CheckupPlanFormPage";

const CheckupPlanCreate = () => <CheckupPlanFormPage mode="create" />;

export default CheckupPlanCreate;
